import { _, $, Backbone, Radio, Foundation } from "../../../vendor";
import { Biscuit, Dependencies, Notification } from "../../utils";
import { parseUrlIntoObject } from "../../utils/Uri";
import InboomaBaseView from "../InboomaBaseView";
import InboomaSelectBox from "../../utils/InboomaSelectBox";

import OffCanvasOrdersForm from "./OffCanvasOrdersForm";
import OffCanvasBehavior from "../../behaviors/Behavior.OffCanvas";

import User from "../../models/User";
import Order from "../../models/Order";
import Reservation from "../../models/Reservation";
import Reservations from "../../collections/Reservations";

import ReservationForm from "./ReservationForm/ReservationsList";
import OffCanvasUsersForm from "../users/OffCanvasUsersForm";

import QuickOrderFormTpl from "../../templates/orders/QuickOrderFormTpl.html";
import { select2 } from "../../../vendor";

/**
 * Add bookings wizard aka "QuickOrderForm"
 *
 * Collect all required booking data, then save it once.
 */

export default InboomaBaseView.extend({
  template: QuickOrderFormTpl,
  el: "#quick-order-form",

  ui: {
    content: "#quick-order-form__content",
    submitBtn: "#quick-order-form__submitBtn",
    userSelectField: "#quick-order-form__user-select",
    breadcrumbElem: ".breadcrumbs li",
    types: "#types",
  },

  events: {
    "click @ui.submitBtn": "_submitForm",
    "click @ui.breadcrumbElem": "_changeStep",
    "click #quick-order-form__add_user": "_toggleNewUser",
    "click .button-abort": "_close",
    "click #inb-quick-order-add-tag": "_showTagList",
    "click .tag-remove-icon": "_removeTag",
    "change #quick-order-tag-select": "_addTag",
    "click #inb-quick-order-close-tags": "_hideTagList",
    "change #inb-quick-order-tag-box-input": "_addCustomTag",
    "click #inb-quick-order-tag-box": "_editTag",
    "change #quick-order-user-by-card-nbr": "_getUserByCardNbr",
    "change #types": "_changeTypes",
  },

  templateContext() {
    return {
      _,
      selectedUser: this._user,
      step: this._step,
      users: Radio.channel("users").request("get:data"),
      Biscuit,
      type: this.type,
    };
  },

  initialize() {
    // Collect dependencies/assets, as in OffCanvasOrdersForm.js

    // temp data for order tags
    this._step = 0;
    this._availableTags = [];
    this._selectedTags = [];
    this._customTagsCount = 0;
    this.type = null;

    const that = this,
      users = Radio.channel("users").request("get:data"),
      params = parseUrlIntoObject();

    $("html,body").scrollTop(0); // So popup's are properly fixed

    // Init local variables
    this._user = new User();

    this._reservations = new Reservations([new Reservation({ _requiresSave: true })]); // Type of collection required
    this._order = new Order();
    this._masteredFirstStep = false;
    this._afterCloseNavigateLink = null;
    document.location.href.indexOf("reservationsList") >= 0
      ? (this._afterCloseNavigateLink = "reservations/reservationsList")
      : (this._afterCloseNavigateLink = "reservations/orders");

    this.modal = new Foundation.Reveal(this.$el, {
      multipleOpened: true,
      closeOnEsc: false,
    });

    if (typeof params.user_id !== "undefined") {
      users.fetchById(params.user_id, function (user) {
        that._order.set("user_id", params.user_id);
        that._user = user;

        new Notification({
          message: that.t("user_added_to_order"),
          duration: 5000,
          icon: "fi fi-torso",
        });
      });
    }

    // fetch order tags
    const RequestHelper = Backbone.Model.extend({
      urlRoot: "/tags?namespace=Orders",
    });

    new RequestHelper(null).fetch({
      success(model, response) {
        console.log("response: ", response);

        if (response.success && response.data.length > 0) {
          // put tags into list of available tags
          for (var i = 0; i < response.data.length; i++) {
            that._availableTags.push(response.data[i]);
          }
          that._setAvailableTags();
        } else {
          console.log("ERROR: failed to get tags response");
        }
      },
      error(model, response) {
        console.log("Error, could not request tags.");
      },
    });

    /*if (Biscuit.get('user.role') == 'manager-location') {
            // Auto-filling the form with the logged in user has been disabled
            // as requested by Elke in Hangouts (5th April 19)
            //that._user = user;
        }*/

    this.modal.open();

    new Dependencies(OffCanvasOrdersForm.prototype._dependencies).then(() => {
      if (typeof Radio._channels["dynamo_start_locations"] !== "undefined") {
        that.render();
      } else {
        OffCanvasOrdersForm.prototype.initDynamoDB(function () {
          that.render();
        });
      }
    });
  },

  _close() {
    const currentUrl = new URL(window.location.href);
    this.modal.close();

    this.unbind();
    this.undelegateEvents();
    this.unbindEvents();
    this.unbindUIElements();
    this.$el.html("");

    Backbone.history.navigate(this._afterCloseNavigateLink + currentUrl.search, { trigger: true });
  },

  _setAvailableTags() {
    // fill list of available tags except already selected tags
    let tagFound,
      tagList = document.getElementById("quick-order-tag-select");

    if (tagList === undefined || tagList == null) return;

    for (var opt, j, i = 0; i < this._availableTags.length; i++) {
      tagFound = false;
      for (j = 0; j < this._selectedTags.length; j++) {
        if (this._selectedTags[j].id == this._availableTags[i].id) {
          tagFound = true;
        }
      }
      if (!tagFound) {
        opt = document.createElement("option");
        opt.text = this._availableTags[i].label;
        opt.value = this._availableTags[i].id;
        tagList.appendChild(opt);
      }
    }
    // fill tag box with already selected tags
    let tagBox = document.getElementById("inb-quick-order-tag-box");
    if (this._selectedTags.length > 0)
      tagBox.insertBefore(
        this._createTagElement(
          this._selectedTags[0].id,
          this._selectedTags[0].label,
          this._selectedTags[0].system,
        ),
        tagBox.childNodes[0],
      );

    for (var i = 1; i < this._selectedTags.length; i++) {
      tagBox.insertBefore(
        this._createTagElement(
          this._selectedTags[i].id,
          this._selectedTags[i].label,
          this._selectedTags[i].system,
        ),
        tagBox.childNodes[tagBox.childNodes.length - 1],
      );
    }
  },

  _showTagList() {
    const tagBox = document.getElementById("inb-quick-order-tag-box");
    const tagSelect = document.getElementById("quick-order-tag-select").parentNode;
    let selectIdx = tagSelect.className.indexOf("hide");
    let boxIdx = tagBox.className.indexOf("hide");
    const iconAdd = document.getElementById("icon-add");
    const iconClose = document.getElementById("icon-close");
    let addIdx = iconAdd.className.indexOf("hide");
    let closeIdx = iconClose.className.indexOf("hide");
    if (selectIdx < 0 && addIdx > 0) {
      return;
    } // already visible
    iconAdd.className += " hide";
    iconClose.className = "inb-c-tag-add-icon";
    // make tag box visible
    if (boxIdx == 0) tagBox.className = tagBox.className.substring(5);
    else {
      var boxClasses = tagBox.className;
      tagBox.className = boxClasses.substring(0, boxIdx) + boxClasses.substring(boxIdx + 5);
    }

    // make selectbox visible
    if (selectIdx == 0) tagSelect.className = tagSelect.className.substring(5);
    else {
      var selectClasses = tagSelect.className;
      tagSelect.className =
        selectClasses.substring(0, selectIdx) + selectClasses.substring(selectIdx + 5);
      console.log("class: ", tagSelect.className);
    }
    // maybe adding some highlightning
  },

  _hideTagList() {
    const iconAdd = document.getElementById("icon-add");
    const iconClose = document.getElementById("icon-close");
    const tagBox = document.getElementById("inb-quick-order-tag-box");
    const tagSelect = document.getElementById("quick-order-tag-select").parentNode;
    iconClose.className.length == 0
      ? (iconClose.className = "hide")
      : (iconClose.className += " hide");
    iconAdd.className = "inb-c-tag-add-icon";
    if (tagSelect.className.indexOf("hide") < 0)
      tagSelect.className.length == 0
        ? (tagSelect.className = "hide")
        : (tagSelect.className += " hide");
    if (tagBox.className.indexOf("hide") < 0)
      tagBox.className.length == 0 ? (tagBox.className = "hide") : (tagBox.className += " hide");
    // maybe removing some highlightning
  },

  _addTag(ev) {
    // add value of select box
    var tag_index,
      tag_id = ev.target.options[ev.target.selectedIndex].value;
    var tagBox = document.getElementById("inb-quick-order-tag-box");
    var tagBoxInput = document.getElementById("inb-quick-order-tag-box-input").parentNode;

    for (var i = 0; i < this._availableTags.length; i++) {
      if (this._availableTags[i].id == tag_id) tag_index = i;
    }
    tagBox.insertBefore(
      this._createTagElement(
        tag_id,
        this._availableTags[tag_index].label,
        this._availableTags[tag_index].system,
      ),
      tagBoxInput,
    );
    this._selectedTags.push(this._availableTags[tag_index]);

    // remove tag from select box and unselect everything
    ev.target.remove(ev.target.selectedIndex);
    ev.target.selectedIndex = 0;
  },

  _addCustomTag(ev) {
    console.log("add custom tag");
    var val = ev.target.value;
    var tagBox = document.getElementById("inb-quick-order-tag-box");

    // add tag to tag box
    this._customTagsCount++;
    tagBox.insertBefore(
      this._createTagElement(-this._customTagsCount, val, false),
      ev.target.parentNode,
    );

    // add tag to list of available tags and list of selected tags
    this._availableTags.push({ id: -this._customTagsCount, label: val });
    this._selectedTags.push({ id: -this._customTagsCount, label: val });

    // clear input box
    ev.target.value = "";
  },

  _editTag(ev) {
    // clicked into tag box - set focus on input box
    document.getElementById("inb-quick-order-tag-box-input").focus();
  },

  _removeTag(ev) {
    const tagBox = document.getElementById("inb-quick-order-tag-box");
    const tagSelect = document.getElementById("quick-order-tag-select");
    const tagContentWrapper = ev.target.parentNode;
    var tagOption = document.createElement("option");

    // search label element, add tag to list of available tags, remove tag from list of selected tags
    for (var i = 0; i < tagContentWrapper.childNodes.length; i++) {
      if (tagContentWrapper.childNodes[i].tagName == "DIV") {
        for (var j = 0; j < tagContentWrapper.childNodes[i].childNodes.length; j++) {
          if (tagContentWrapper.childNodes[i].childNodes[j].tagName == "LABEL") {
            // label element found, create option for select box
            tagOption.text = tagContentWrapper.childNodes[i].childNodes[j].innerHTML;
            tagOption.value = tagContentWrapper.parentNode.getAttribute("tag_id");

            // remove tag from list of selected tags
            for (var k = 0; k < this._selectedTags.length; k++) {
              if (this._selectedTags[k].id == tagContentWrapper.parentNode.getAttribute("tag_id")) {
                this._selectedTags.splice(k, 1);
                tagSelect.add(tagOption);
                tagBox.removeChild(tagContentWrapper.parentNode);
                return;
              }
            }
          }
        }
      }
    }
  },

  _createTagElement(id, label, isSystem) {
    // create and append tag element
    var tagElement = document.createElement("div");
    var tagContent = document.createElement("div");
    isSystem
      ? (tagElement.className = "tag-element system")
      : (tagElement.className = "tag-element");
    tagElement.setAttribute("tag_id", id);
    tagContent.className = "content-wrapper";
    var labelWrapper = document.createElement("div");
    labelWrapper.className = "label-wrapper";
    var tagLabel = document.createElement("label");
    tagLabel.innerHTML = label;
    var tagRemoveIcon = document.createElement("div");
    tagRemoveIcon.className = "tag-remove-icon";
    tagRemoveIcon.innerHTML = "x";

    labelWrapper.appendChild(tagLabel);
    tagContent.appendChild(labelWrapper);
    tagContent.appendChild(tagRemoveIcon);
    tagElement.appendChild(tagContent);

    return tagElement;
  },

  _createOrderTagList(tags) {
    let tagList = "";
    for (var i = 0; i < tags.length; i++) {
      tagList += tags[i].label + ",";
    }
    console.log("taglist: ", tagList);
    return tagList.slice(0, -1);
  },

  _changeStep(ev) {
    const target = $(ev.target);

    if (target) {
      const val = Number(target.attr("data-goto-step"));

      if (val != null) {
        if (val !== this._step && val <= 1 && this._masteredFirstStep) {
          this._step = val;
          this.render();
        }
      }
    }
  },

  _toggleNewUser() {
    this._user = new User();
    this.render();
  },

  _getUserByCardNbr(ev) {
    console.log("target: ", ev.target);

    if (ev.target.value.length == 12) {
      console.log("card nbr changed and has 12 characters");

      // fetch user by card nbr
      const that = this;
      const RequestHelper = Backbone.Model.extend({
        urlRoot: "/users?id_card_nbr=" + ev.target.value,
      });

      new RequestHelper(null).fetch({
        success(model, response) {
          if (response.success && response.data.length > 0) {
            // there should only be one user with this card-number
            // set model
            that._user = new User();
            that._user.attributes = Object.assign(that._user.attributes, model.attributes.data[0]);
            that.render();
          } else {
            console.log("ERROR: failed to get user by card number response");
          }
        },
        error(model, response) {
          console.log("Error, could not request user by card number.");
        },
      });
    }
  },

  _submitForm() {
    this.$el.find('button[type="submit"]').trigger("click");

    if (!this.$el.find(".off-canvas__form-error").not(".hide").length) {
      if (this._step == 0) {
        this._masteredFirstStep = true; // Needed for breadcrumb
        this._step++;
        this.render(); // @todo Performance: Unnecessary re-render of whole component
      }
    }
  },

  onRender() {
    const that = this;

    if (this._step === 0) {
      this._reservationForm = new ReservationForm({
        collection: that._reservations,
        parent: null,
        toggleReservation: false,
        preventFromSubmit: true, // Only validate form, do not submit till we say so
        el: that.getUI("content"),
      });
    } else if (this._step === 1) {
      this._userForm = new OffCanvasUsersForm({
        model: that._user,
        collection: Radio.channel("users").request("get:data"),
        openCanvas: false,
        el: that.getUI("content"),
        afterSaveSuccess2: (user, view, response) => {
          // 1.) Process starts here - user saved!

          if (typeof response.data[0] !== "undefined") {
            that._user = response.data[0];
          } else {
            that._user = user.toJSON();
          }

          const collection = Radio.channel("orders").request("get:data"),
            reservation = that._reservations.models[0];

          // 2.) Format order as required by API

          that._order.set({
            client_id: Number(Biscuit.get("user.client_id")),
            user_id: that._user.id,
          });
          if (that.type !== null) {
            that._order.set({
              client_id: Number(Biscuit.get("user.client_id")),
              user_id: that._user.id,
              types: that.type,
            });
          }

          that._order = OffCanvasBehavior.prototype.normalizeModel(that._order);

          // 3.) Link order with reservation, then reservation.save()
          let resOrder = {
            user_id: that._order.get("user_id"),
            client_id: that._order.get("client_id"),
            status: that._order.get("status"),
          };
          if (that.type !== null) {
            resOrder.types = that.type;
          }
          if (that._selectedTags.length > 0)
            resOrder.tag_list = that._createOrderTagList(that._selectedTags);

          reservation.set({
            order_id: null,
            order: resOrder,
          });

          reservation
            .on("changed", function () {
              // reservation "afterSave"

              reservation.off("changed").off("request:error");

              that._order.set("id", reservation.attributes.order_id);

              that._order.fetch({
                success() {
                  collection.set(new Order(that._order.toJSON()), {
                    add: true,
                    merge: true,
                    remove: false,
                  });

                  that._afterCloseNavigateLink = "orders/" + that._order.get("id") + "/edit";

                  console.log("order fetched: ", that._order);

                  that._close();
                },
              });
            })
            .on("request:error", function () {
              alert(that.t("request_error") + " (POST /reservations)");

              reservation.off("changed").off("request:error");
            });

          // Finally: Trigger save!
          that._reservationForm.bulkSaveReservations();
        },
      });

      const users = Radio.channel("users").request("get:data");

      const selectBox = new InboomaSelectBox({
        el: this.$("#quick-order-form__user-select-container"),
        collection: users, // @todo where active === TRUE
        sortBy: "created",
        sortDirection: "desc",
        placeholder: this.t("add_existing_user"),
        selectedItem: that._user,
        advancedUserList: true,
        quickOrder: true,
        inputStyle: "width:200px;",
        listItemContent: (model) => {
          /*
                    if (typeof model.get('role') !== 'undefined' && model.get('role') === 'admin') {
                        return '';
                    }*/

          return model.get("first_name") + " " + model.get("last_name");
        },
        onSearch: (query) => {
          users._filterParams = {
            q: query,
            sort: "last_name",
            sortDirection: "asc",
          };
          users._skipPagination = true;

          users.fetchNextPage(_.noop);
        },
        onSelectItem: (model) => {
          that._user = model;
          that.render();
        },
      });
    }
    that._setAvailableTags();
  },

  _changeTypes(ev) {
    const that = this;
    var val = ev.target.value;
    if (val === "please select") {
      return;
    }
    that.type = val;
  },
});
